module.exports = __webpack_public_path__ + "img/hr.71afb901.png";